import { SVGProps } from "react";

const NTHUModsLogo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 74 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="2"
        y="5.00003"
        width="61"
        height="61"
        rx="13"
        fill="white"
        stroke="black"
        strokeWidth="4"
      />
      <rect x="45.0001" width="5" height="11" rx="2.5" fill="black" />
      <rect x="15" width="5" height="11" rx="2.5" fill="black" />
      <rect
        x="11"
        y="18"
        width="61"
        height="61"
        rx="13"
        fill="white"
        stroke="black"
        strokeWidth="4"
      />
      <rect x="21.0001" y="32" width="11" height="33" rx="5.5" fill="black" />
      <rect x="50.9999" y="32" width="11" height="33" rx="5.5" fill="black" />
      <rect x="36.0001" y="39" width="11" height="11" rx="5.5" fill="black" />
      <rect x="24" y="13" width="5" height="11" rx="2.5" fill="black" />
      <rect x="54" y="13" width="5" height="11" rx="2.5" fill="black" />
    </svg>
  );
};

export default NTHUModsLogo;
